/**
 * `?returnTo=<path>` on `/signin` and `/signup`: where to send someone once
 * they are signed in, when they came to reach a page (a team's join page,
 * `/books/join/<token>`) rather than the app. Without it both screens end
 * at `/` (or the preview-code screen, or the waitlist).
 *
 * The value arrives in a URL anyone can build, so only a path on THIS site
 * is followed: it must start with one `/`, and nothing a browser's URL
 * parser would turn into a second one (`//host`, `/\host`, a tab or newline,
 * which the parser drops) — any of those would be another origin.
 */

// a backslash, or any control character (the URL parser drops tabs and
// newlines, so `/\t/evil.example` would become `//evil.example`)
// eslint-disable-next-line no-control-regex
const UNSAFE = /[\\\u0000-\u001f\u007f]/;

/** The path to go back to, or null when there is none worth following. */
export const safeReturnTo = (raw) =>
  typeof raw === 'string' &&
  raw.startsWith('/') &&
  !raw.startsWith('//') &&
  !UNSAFE.test(raw)
    ? raw
    : null;

/** `path` carrying a return address, or `path` itself when there is none. */
export const withReturnTo = (path, returnTo) =>
  returnTo ? `${path}?returnTo=${encodeURIComponent(returnTo)}` : path;
